import {
  Container,
  ContainerProyectos,
  Card,
  ImgProyectFront,
  ImgProyectBack,
  ContainerTitulo,
  A,
} from "../styles/works";
import { Titulo } from "../styles/skills";
import logoDog from "../img/facedog.png";
import logoBarber from "../img/barber.png";
import logoPokemon from "../img/pokemon.png";
import logoAbierto from "../img/abierto.png";
const Works = () => {
  return (
    <Container>
      <ContainerTitulo>
        <Titulo>Proyectos</Titulo>
      </ContainerTitulo>

      <ContainerProyectos>
        <A href="https://pi-dogs-gamma.vercel.app/" target="_blank">
          <Card>
            <ImgProyectFront src={logoDog}></ImgProyectFront>

            <ImgProyectBack src={logoAbierto}></ImgProyectBack>
          </Card>
        </A>
        <A href="https://barber-app-alpha.vercel.app/#/" target="_blank">
          <Card>
            <ImgProyectFront src={logoBarber}></ImgProyectFront>

            <ImgProyectBack src={logoAbierto}></ImgProyectBack>
          </Card>
        </A>
        <A href="https://demopokemons-amador-a.vercel.app/" target="_blank">
          <Card>
            <ImgProyectFront src={logoPokemon}></ImgProyectFront>

            <ImgProyectBack src={logoAbierto}></ImgProyectBack>
          </Card>
        </A>
      </ContainerProyectos>
    </Container>
  );
};

export default Works;
